var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 9.16683H9.99967V5.8335M13.333 9.16683C13.333 11.0078 11.8406 12.5002 9.99967 12.5002C8.15873 12.5002 6.66634 11.0078 6.66634 9.16683C6.66634 7.32588 8.15873 5.8335 9.99967 5.8335M13.333 9.16683C13.333 7.32588 11.8406 5.8335 9.99967 5.8335M9.99967 15.8335V18.3335M8.33301 15.8335L4.99967 19.1668M11.6663 15.8335L14.9997 19.1668M17.4997 15.8335V2.50016H2.49967V15.8335M0.833008 15.8335H19.1663M9.99967 2.50016V0.833496",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/board.dbfe1eff.svg";
export { ForwardRef as ReactComponent };